export default __webpack_public_path__ + "static/media/evo-girl.8d042c94.webp";